"use client";

import React from "react";
import { MapPin, Phone, Mail, Facebook, Twitter, Instagram } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 animate-pulse rounded-md bg-muted/20" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <NavigationMenu viewport={false} className="max-w-full justify-start">
      <NavigationMenuList className="flex-col items-start gap-2 space-x-0">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i} className="w-full">
            <NavigationMenuLink asChild className="w-full justify-start bg-transparent px-0 py-1 text-muted-foreground transition-colors hover:bg-transparent hover:text-primary focus:bg-transparent data-[active=true]:bg-transparent">
              <Link to={item.href || "#"}>{item.label}</Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function FooterInfo() {
  const businessDescription = "AFREX INTEGRATED GROUP is a premium multi-country business platform providing global trade, logistics, and industrial supply solutions across the USA, Kenya, and Guinea. We bridge markets with architectural precision and corporate excellence.";
  const address = "Prima Asmara LLC, USA | Afrex Solutions, Kenya & Guinea";
  const phone1 = "+17208319485";
  const phone2 = "+254 113 965 539";
  const email = "info@afrexintegrated.com";
  const socials = [{
    name: "Facebook",
    icon: Facebook,
    href: "#"
  }, {
    name: "Twitter",
    icon: Twitter,
    href: "#"
  }, {
    name: "Instagram",
    icon: Instagram,
    href: "#"
  }];
  return <section data-section-id="259801" id="footer" className="bg-background border-t border-primary py-16 text-foreground">
      <div className="container mx-auto px-6 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12 md:gap-8">
          {}
          <div className="md:col-span-5 lg:col-span-4">
            <Link to="/" className="inline-block">
              <WvcLogo className="h-12 w-auto text-secondary" />
            </Link>
            <p className="mt-6 text-sm leading-relaxed text-muted-foreground">
              {businessDescription}
            </p>
          </div>

          {}
          <div className="md:col-span-3 lg:col-span-4 lg:justify-self-center">
            <h3 className="font-default mb-6 text-lg font-bold tracking-tight text-secondary">
              Quick Links
            </h3>
            <MenuProvider menu_id="17">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="md:col-span-4 lg:col-span-4 lg:justify-self-end">
            <h3 className="font-default mb-6 text-lg font-bold tracking-tight text-secondary">
              Global Presence
            </h3>
            <ul className="flex flex-col gap-4 text-sm text-muted-foreground">
              {address && <li className="flex items-start gap-3">
                  <MapPin className="mt-0.5 size-5 shrink-0 text-primary" />
                  <span>{address}</span>
                </li>}
              {(phone1 || phone2) && <li className="flex items-start gap-3">
                  <Phone className="mt-0.5 size-5 shrink-0 text-primary" />
                  <div className="flex flex-col gap-1 sm:flex-row sm:gap-2">
                    {phone1 && <span>{phone1}</span>}
                    {phone1 && phone2 && <span className="hidden sm:inline">|</span>}
                    {phone2 && <span>{phone2}</span>}
                  </div>
                </li>}
              {email && <li className="flex items-center gap-3">
                  <Mail className="size-5 shrink-0 text-primary" />
                  <span>{email}</span>
                </li>}
            </ul>

            <div className="mt-8 flex items-center gap-4">
              {socials.map((social, i) => {
              const Icon = social.icon;
              return <Link key={social.name} data-index={i} to={social.href} className="rounded-md bg-muted p-2 text-secondary transition-colors hover:bg-primary hover:text-primary-foreground" aria-label={social.name}>
                    <Icon className="size-5" />
                  </Link>;
            })}
            </div>
          </div>
        </div>

        {}
        <div className="mt-16 border-t border-border pt-8 text-center text-xs text-muted-foreground">
          <p>
            &copy; {new Date().getFullYear()} AFREX INTEGRATED GROUP. All Rights Reserved. Premium Logistics & Global Trade.
          </p>
        </div>
      </div>
    </section>;
}